import hexToRgb from "hex-to-rgb";
import { GlobalData } from "serverData";

const toRgb = function(hex) {
  let rgb = hexToRgb(hex);
  return `rgb(${rgb[0]},${rgb[1]},${rgb[1]})`;
};

const toRgba = function(hex, alpha) {
  let rgb = hexToRgb(hex);
  return `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`;
};

// for cache invalidation
const querystring = `?v=${process.env.REACT_APP_VERSION}`;

const bgImageUrl = function(path) {
  return `url("${GlobalData.imgBasePath}${path}${querystring}")`;
};

export { toRgb, toRgba, bgImageUrl };
